export enum InvoiceMetaEnum {
  USER_LIMIT = 'user_limit',
  IMAGE_CAPTURING_OWN_DEVICE = 'image_storage_own_device',
  IMAGE_CAPTURING_KRISTA_KROMA = 'cloud_storage_krista_kroma',
  CAPTURE_VIDEO = 'capture_video',
  GEM_PASSPORT = 'gem_passport',
  GEM_PASSPORT_LITE = 'gem_passport_Lite',
  VERIFY_GEM_PASSPORT = 'verify_gem_passport',
}
